import { PriceListListResponseType } from "@sellar-io/api-v2/types";

type PriceList = PriceListListResponseType[number];
type PriceListOrderRules = Pick<
  PriceList,
  "PriceListOrderRules"
>["PriceListOrderRules"];

export const filterOrderRulesWithContainerType = ({
  orderRules,
  containerType,
}: {
  orderRules: PriceListOrderRules;
  containerType: "bottle" | "can";
}) => {
  return orderRules.filter(
    (rule) => containerType === rule.itemType || rule.itemType === "any",
  );
};

export const getPriceListsWithOrderRuleContainerType = ({
  priceListList,
  containerType,
}: {
  priceListList: PriceList[];
  containerType: "bottle" | "can";
}) => {
  return priceListList
    .filter((priceList) => {
      return !!filterOrderRulesWithContainerType({
        orderRules: priceList.PriceListOrderRules,
        containerType,
      }).length;
    })
    .map((priceList) => {
      const priceListDiscounts = filterOrderRulesWithContainerType({
        orderRules: priceList.PriceListOrderRules,
        containerType,
      });

      return {
        id: priceList.id,
        name: priceList.name,
        PriceListDiscounts: priceListDiscounts,
      };
    });
};
